var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-app-bar',{attrs:{"color":_vm.color ? _vm.color : 'primary',"dark":""}},[_c('v-toolbar-title',[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }